import { Permissions } from '../client_auth/permissions'
userSummary.$inject = ['adminApi', 'userInfo', 'userActions', 'domainInfo', 'auth']

export default function userSummary(adminApi, userInfoService, userActions, domainInfoService, auth) {
  return {
    restrict: 'EA',
    scope: {
      email: '=?userSummary',
      uuid: '=?userUuid'
    },
    link: function(scope) {
      scope.userInfoService = userInfoService
      scope.UI = userInfoService.UI
      userActions.populateIsAuthorized(userActions.individualActions).then(actions => {
        scope.actions = actions;
      });
      auth.hasUserOpsPermission().then(hasPermission => {
        scope.canAddRemoveUsersToDomainSchools = hasPermission;
      });

      scope.$watch('email', function(newEmail) {
        if (newEmail) {
          userInfoService.refreshUser(newEmail, '')
        }
      })

      scope.$watch('uuid', function(newUuid) {
        if (newUuid) {
          userInfoService.refreshUser('', newUuid)
        }
      })

      scope.performingAction = false
      scope.performAction = function(action, domain, schools) {
        scope.performingAction = true
        if (!domain) {
          domain = (userInfoService.userInfo.domains && userInfoService.userInfo.domains[0]) || null
        }
        userActions[action.key] &&
          userActions[action.key]({
            domain,
            users: [
              { ...userInfoService.userInfo.user_graph, ...userInfoService.userInfo.user_account }
            ],
            schools
          }).then(
            function(result) {
              scope.performingAction = false
              console.log(result)
              if (result) {
                // refresh the user
                var refreshEmail =
                  (result.user_graph && result.user_graph.email) ||
                  userInfoService.userInfo.user_graph.email
                userInfoService.refreshUser(refreshEmail, result.user_graph.uuid)

                // if the user's domain is the same as the domain loaded in the domain detail page, refresh user list
                if (
                  domainInfoService.domain &&
                  userInfoService.userInfo.domains &&
                  domainInfoService.domain.uuid === userInfoService.userInfo.domains[0].uuid
                ) {
                  domainInfoService.refreshUsers().then(function() {
                    console.log('finished refreshing users')
                  })
                }
              }
            },
            function(reason) {
              console.log(action.label + ' failed: ' + reason)
              scope.performingAction = false
            }
          )
      }
    },
    template: require('./_userSummary.html')
  }
}
